import userNameString from "res-extensions/build/userNameString";

export default user => (user ? user.name || userNameString(user) : "System");
